import React, { useEffect, useState } from "react"
import Send from "../../core/communication"
import { AssistanceDetailsScreen } from "../../screen/AssistanceDetails"
import { useLocation, useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { useScope } from "../SelectProjectCompanyContainer"
import moment from "moment"

const AssistanceDetailsContainer = () => {
  const { id } = useParams()
  const state = useLocation().state
  const { scope } = useScope()
  const assistanceDate = useSelector((state) => state.app.assistanceDate) || []
  const assistanceUsers = useSelector((state) => state.app.assistanceUsers) || []
  const assistanceTechnician = useSelector((state) => state.app.assistanceTechnician) || {}
  const users = useSelector((state) => state.app.users)
  const [loading, setLoading] = useState(false)
  const [details, setDetails] = useState([])

  const loadData = async () => {
    setLoading(true)
    const newDetails = await Send.get(`/assistance/details/${id}`)

    await Promise.all([newDetails]).then(([newDetails]) => {
      setDetails(newDetails || [])
    })

    setLoading(false)
  }

  useEffect(() => {
    if (id || scope?.id) {
      loadData()
    }
  }, [id, scope?.id])

  const formatTec = {
    name: state.values.Tecnico,
  }

  const formatProducer = {
    name: state.values.Produtor,
    email: users.filter((item) => item.name === state.values.Produtor).map(item => item.email),
  }

  return (
    <AssistanceDetailsScreen
      {...{
        assistanceUsers: assistanceUsers.length && assistanceUsers || formatProducer,
        assistanceDetails: details,
        assistanceTechnician: assistanceTechnician.length && assistanceTechnician || formatTec,
        assistanceDate: assistanceDate.length && assistanceDate || moment(state.values.Data.value).format("DD/MM/YYYY"),
        loading,
      }}
    />
  )
}

export default AssistanceDetailsContainer
